import * as React from "react"
import { ChevronDown } from "lucide-react"
import { useIntl } from "react-intl"
import { Button } from "@/components/ui/button"
import { Calendar } from "@/components/ui/calendar"
import {
  Popover,
  PopoverContent,
  PopoverTrigger,
} from "@/components/ui/popover"
import { useSalonDateFnsLocale } from "@/hooks/me/use-salon"

interface AppointmentsToolbarProps {
  date: Date
  onDateChange: (date: Date) => void
}

export function AppointmentsToolbar({ date, onDateChange }: AppointmentsToolbarProps) {
  const intl = useIntl()
  const locale = useSalonDateFnsLocale()
  const [open, setOpen] = React.useState(false)

  return (
    <div className="h-14 flex items-center justify-center">
      <Popover open={open} onOpenChange={setOpen}>
        <PopoverTrigger asChild>
          <Button
            variant="outline"
            data-empty={!date}
            className="data-[empty=true]:text-muted-foreground justify-start text-left font-normal w-auto"
          >
            {intl.formatDate(date, { format: "long" })}
            <ChevronDown className="ml-2 h-4 w-4 opacity-50" />
          </Button>
        </PopoverTrigger>
        <PopoverContent className="w-auto p-0">
          <Calendar
            mode="single"
            locale={locale}
            selected={date}
            defaultMonth={date}
            onSelect={(selectedDate) => {
              if (selectedDate) {
                onDateChange(selectedDate)
                setOpen(false)
              }
            }}
          />
        </PopoverContent>
      </Popover>
    </div>
  )
}